<template>
  <div class="hdrSearch" v-click-outside="close">
    <div class="hdrSearch__field">
      <v-icon small class="hdrSearch__icon">mdi-magnify</v-icon>
      <input
        v-model="term"
        class="hdrSearch__input"
        type="text"
        placeholder="Order suchen (Nr. oder E-Mail)…"
        @focus="onInput"
        @input="onInput"
        @keydown.esc="close"
      />
      <v-progress-circular
        v-if="searching"
        indeterminate
        size="14"
        width="2"
        class="hdrSearch__spinner"
      />
    </div>

    <div v-if="open && (results.length || searched)" class="hdrSearch__dropdown">
      <div v-if="!results.length" class="hdrSearch__empty">
        Keine Treffer — Order-Nummer (z.&nbsp;B. 90353) oder exakte E-Mail eingeben.
      </div>
      <div
        v-for="o in results"
        :key="o.uid"
        class="hdrSearch__row"
        @click="openResult(o)"
      >
        <span class="hdrSearch__name">{{ o.orderName }}</span>
        <span class="hdrSearch__status" :class="'hdrSearch__status--' + (o.status || '').toLowerCase()">
          {{ o.status }}
        </span>
        <span class="hdrSearch__customer">
          {{ (o.shippingAddress && o.shippingAddress.firstName) || "" }}
          {{ (o.shippingAddress && o.shippingAddress.lastName) || "" }}
        </span>
        <span class="hdrSearch__date">{{ fromNow(o.orderDate) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getDateFromNow, openOrderModal, searchOrders } from "@/utils";

export default {
  name: "HeaderOrderSearch",
  data() {
    return {
      term: "",
      results: [],
      open: false,
      searching: false,
      searched: false,
      debounceTimer: null,
    };
  },
  methods: {
    fromNow(date) {
      return date ? getDateFromNow(date) : "";
    },
    onInput() {
      clearTimeout(this.debounceTimer);
      if (this.term.trim().length < 2) {
        this.results = [];
        this.searched = false;
        this.open = false;
        return;
      }
      this.open = true;
      this.debounceTimer = setTimeout(this.runSearch, 350);
    },
    close() {
      this.open = false;
    },
    async runSearch() {
      const raw = this.term.trim();
      if (raw.length < 2) return;
      this.searching = true;
      try {
        this.results = await searchOrders(raw, 10);
        this.searched = true;
      } catch (e) {
        console.warn("header order search failed:", e);
      } finally {
        this.searching = false;
      }
    },
    openResult(o) {
      this.close();
      openOrderModal(o.uid);
    },
  },
};
</script>

<style lang="scss" scoped>
.hdrSearch {
  position: relative;
  width: min(420px, 40vw);

  &__field {
    display: flex;
    align-items: center;
    background: #f4f3f7;
    border-radius: 999px;
    padding: 0 14px;
    height: 40px;
    transition: box-shadow 0.15s, background 0.15s;

    &:focus-within {
      background: #fff;
      box-shadow: 0 0 0 2px rgba(123, 92, 214, 0.35);
    }
  }
  &__icon {
    color: rgba(0, 0, 0, 0.4) !important;
    margin-right: 8px;
  }
  &__input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.8);

    &::placeholder {
      color: rgba(0, 0, 0, 0.35);
    }
  }
  &__spinner {
    color: #7b5cd6;
  }

  &__dropdown {
    position: absolute;
    top: 48px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 8px 30px rgba(16, 24, 40, 0.18);
    padding: 6px;
    z-index: 20;
    max-height: 420px;
    overflow-y: auto;
  }
  &__empty {
    padding: 14px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.5);
  }
  &__row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border-radius: 10px;
    cursor: pointer;

    &:hover {
      background: #faf9fc;
    }
  }
  &__name {
    font-weight: 700;
    font-size: 13.5px;
    color: #7b5cd6;
    white-space: nowrap;
  }
  &__status {
    font-size: 10px;
    font-weight: 700;
    border-radius: 999px;
    padding: 1px 8px;
    background: #f1f0f5;
    color: rgba(0, 0, 0, 0.55);
    white-space: nowrap;

    &--ready_for_fulfill { background: #e3f2fd; color: #1565c0; }
    &--order_created, &--in_progress, &--waiting_for_fulfill { background: #fff6e8; color: #b26a00; }
    &--in_fulfill { background: #ede7f6; color: #5e35b1; }
    &--fulfilled { background: #e8f5e9; color: #2e7d32; }
    &--fulfill_error { background: #ffebee; color: #c62828; }
    &--closed { background: #f1f0f5; color: rgba(0, 0, 0, 0.5); }
  }
  &__customer {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.6);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &__date {
    margin-left: auto;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.4);
    white-space: nowrap;
  }
}
</style>
